import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroBadges, heroImage } from '../data/copy';
export function Hero() {
  return <header className="w-full bg-ivory" data-id="element-121" data-mp="9ka2cotbuas6">
      <div className="mx-auto max-w-4xl px-6 pb-10 pt-7 text-center sm:pt-9 lg:pb-12" data-id="element-122" data-mp="9l34tdl96e4i">
        <Pill tone="terracotta" data-id="element-123" data-mp="4n9zsnvorq5t">Complete Art Teaching System</Pill>

        <h1 className="mx-auto mt-3 max-w-2xl font-display text-[1.35rem] leading-snug text-terracotta-deep sm:text-2xl" data-id="element-124" data-mp="129qurmgy5roe">
          Plan your entire year of art classes today.
        </h1>

        {/* The complete product mockup sits directly under the headline. */}
        <div className="relative mt-7" data-id="element-125" data-mp="sd48ct8z2sk9">
          <div className="absolute inset-x-0 bottom-6 top-12 rounded-4xl bg-sand" aria-hidden="true" data-id="element-126" data-mp="nb6kflpmn9kz" />
          <img src={heroImage} alt="The complete Art Flow Archive: six master volumes, six bonus booklets and printable visual resources." className="relative mx-auto w-full max-w-[19rem] sm:max-w-lg lg:max-w-2xl" width={1232} height={1232} sizes="(max-width: 640px) 304px, (max-width: 1024px) 512px, 672px" decoding="async" loading="eager" {...{
          fetchpriority: 'high'
        }} data-id="element-127" data-mp="3d2l95b1th306" />
        </div>

        <p className="mx-auto mt-3 max-w-xl font-sans text-[0.95rem] leading-relaxed text-stone sm:text-base" data-id="element-128" data-mp="399jm7a81g94j">
          Everything you need to teach with confidence — without spending your
          Sundays planning.
        </p>

        {/* First CTA — jumps straight to the offer section, where the price is. */}
        <div className="mt-6" data-id="element-129" data-mp="35aawqhk16xes">
          <CtaButton href="#offer" size="large" className="w-full sm:w-auto" data-id="element-130" data-mp="2qjv8etwbj9ce">
            Get the complete system
          </CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-131" data-mp="2vjpy4u4cxsvv">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-stone sm:text-xs" data-id="element-132" data-mp="2hkghjtc8owrd">
              <CheckIcon className="h-3.5 w-3.5 text-terracotta" strokeWidth={2.4} aria-hidden="true" data-id="element-133" data-mp="2lk8qw89gj6xs" />
              {badge}
            </li>)}
        </ul>
      </div>
    </header>;
}